<template>
<div>
    <div v-if="formState === 'signUp'">
        <v-card  >
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="form.username"
                            color="pink darken-2"
                            :rules="[rules.required, rules.email]"
                            label="Email"
                            required>
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" >
                        <v-text-field
                            v-model="form.password"
                            color="pink darken-2"
                            :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.min]"
                            :type="showPassword1 ? 'text' : 'password'"
                            label="Password"
                            name="password1"
                            hint="At least 8 characters"
                            counter
                            @click:append="showPassword1 = !showPassword1">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" >
                        <v-text-field
                            v-model="form.password2"
                            color="pink darken-2"
                            :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, passwordConfirmationRule]"
                            :type="showPassword2 ? 'text' : 'password'"
                            label="Password confirmation"
                            name="password2"
                            hint="At least 8 characters"
                            counter
                            @click:append="showPassword2 = !showPassword2">
                        </v-text-field>
                    </v-col>
                </v-row>
                 <v-row>
                    <v-col cols="12" >
                        <v-card-text v-if="formError" class="mt-0 pa-0 pl-2 h6">
                            {{this.formErrorText}}
                        </v-card-text>
                    </v-col>
                </v-row>               
                <v-row>
                    <v-col cols="12" >
                        <v-btn outlined color="pink darken-2"  block v-on:click='signUp'>Sign Up</v-btn>
                    </v-col>
                </v-row>
                
            </v-container>
        </v-card>
    </div>

   <div>

      <div v-if="formState === 'confirmSignUp'">
          <v-row>
              <v-col cols="12" >
                  <v-text-field
                      v-model="form.authCode"
                      color="pink darken-2"
                      :rules="[rules.required]"
                      label="Auth Code (check your email)"
                      hint="">
                  </v-text-field>
              </v-col>
          </v-row>
         <v-row>
            <v-col cols="12" >
                <v-card-text v-if="formError" class="mt-0 pa-0 pl-2 h6">
                    {{this.formErrorText}}
                </v-card-text>
            </v-col>
        </v-row>             
          <v-row>
            <v-col cols="12" >
                <v-btn outlined color="pink darken-2"  block v-on:click='confirmSignUp'>Confirm sign up</v-btn>
            </v-col>
            </v-row>

          <v-row>
            <v-col cols="12" >
                <v-card-text  class="mt-0 pa-0 pl-2 text-subtitle-2 grey--text text--darken-1">
                    Check your email for your Auth code
                  </v-card-text>
            </v-col>
            </v-row>


      </div>
   </div>
</div>
</template>

<script >
import {Auth} from 'aws-amplify'

export default {
    name: 'home',
    props: ['toggle'],
    data() {
        return {
            formError: false,
            formErrorText: "",
            formState: 'signUp',
            showPassword1: false,
            showPassword2: false,            
            form: {
                username: '',
                password: '',
                password2: ''
          },
        rules: {
            required: value => !!value || 'Required.',
            min: v => v.length >= 8 || 'Min 8 characters',
            emailMatch: () => (`The email and password you entered don't match`), 
            email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
            }, 
        }             
      }
    },
   computed: {
       passwordConfirmationRule() {
         return () => (this.form.password === this.form.password2) || 'Passwords must match'
       }
   },    
    methods: {
        async signUp() {
            this.formErrorText=false
            const {username, password} = this.form

            await Auth.signUp({ username, password})
              .then((value) => {
                console.log("The Promise is resolved!", value);
                this.formState = 'confirmSignUp'
              })
              .catch((error) => {
                console.error("The Promise is rejected!", error);
                this.formError=true
                 console.log(typeof error)
                 console.log(JSON.stringify(error))
                this.formErrorText=error
              })
              .finally(() => {
                console.log(
                  "The Promise is settled, meaning it has been resolved or rejected."
                );
              });

        },
        async confirmSignUp() {

            this.formErrorText=false
            const { username, authCode } = this.form

            console.log("AuthCode: " + authCode)
            await Auth.confirmSignUp(username, authCode)
              .then((value) => {
                console.log("The Promise is resolved!", value);
                this.$router.push({path: 'welcome'});
              })
              .catch((error) => {
                console.error("The Promise is rejected!", error);
                this.formError=true
                 console.log(typeof error)
                 console.log(JSON.stringify(error))
                this.formErrorText=error
              })

    
        }
    }
} 

</script>


<style>

.formcontainer {
     display: flex;
     flex-direction: column;
     width: 500px;
     margin: 0 auto;
}
.input {
     margin-bottom: 7px;
     height: 38px;
     border: none;
     outline: none;
     border-bottom: 2px solid #ddd;
     font-size: 20px;
}
.button {
     height: 45px;
     border: none;
     outline: none;
     background-color: #dddddd;
     margin-top: 8px;
     cursor: pointer;
     font-size: 18px;
}
.button:hover {
     opacity: .7
}
</style>